const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_BULK_SUBMIT_STATUS': {
      const {res_data={},res_code='' } = action.data
      return {
        ...state,
        submitStatus: action.data === '0' ? 'success' :
        !res_data?.show_preview &&
         res_code !== '0'
            ? 'failure'
            : '',
        errorData: action.data?.res_data || {},
      };
    }
    case 'SET_ERROR_DATA': {
      return {
        ...state,
        errorData: action.data || '',
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
